import { render } from "./deseaseData.vue?vue&type=template&id=02e0a55c"
import script from "./deseaseData.vue?vue&type=script&lang=js"
export * from "./deseaseData.vue?vue&type=script&lang=js"

import "./deseaseData.vue?vue&type=style&index=0&id=02e0a55c&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__